import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=36acc2fc&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36acc2fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36acc2fc')) {
      api.createRecord('36acc2fc', component.options)
    } else {
      api.reload('36acc2fc', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=36acc2fc&scoped=true&", function () {
      api.rerender('36acc2fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2pa1WkCBA2IWo/JS/comp/Accordion.vue"
export default component.exports